import { Component, OnInit } from '@angular/core';
import { UserApi } from '@shared-features/services';

@Component({
  selector: 'app-welcome-card',
  templateUrl: './welcome-card.component.html',
  styleUrls: ['./welcome-card.component.scss'],
})
export class WelcomeCardComponent implements OnInit {
  userName: string;
  constructor(private userApi: UserApi) {}

  ngOnInit(): void {
    this.userName =
      this.userApi.currentUser$.value?.firstName + ' ' + this.userApi.currentUser$.value?.lastName;
  }
}
